import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

import { StatusDropdownContext } from './table';
import { Modal } from '@material-ui/core';

function StatusDropdown({ params }) {
  const tableProps = React.useContext(StatusDropdownContext);

  const adminStatus = params.data.adminStatus;

  const [openModal, setOpenModal] = React.useState(false);
  const [clickedStatus, setClickedStatus] = React.useState('');

  const isSelectDisabled = (() => {
    if (adminStatus === 'not_needed') return false;

    if (adminStatus !== 'accepted') return false;

    if (params.data.evaluatorUserId) return true;

    return false;
  })();

  return (
    <div className='w-full '>
      <FormControl variant='outlined' className='w-full '>
        <Select
          labelId='demo-simple-select-helper-label'
          id='demo-simple-select-helper'
          value={adminStatus}
          disabled={isSelectDisabled}
          onChange={(event) => {
            setOpenModal(true);
            setClickedStatus(event.target.value);
          }}
        >
          <MenuItem value='pending'>Pending</MenuItem>

          <MenuItem value='accepted'>
            {adminStatus === 'accepted' ? 'Accepted' : 'Accept'}
          </MenuItem>
          {adminStatus === 'not_needed' && (
            <MenuItem value='not_needed'>Not needed</MenuItem>
          )}
        </Select>
      </FormControl>

      <Modal open={openModal}>
        <div className='relative overflow-y-auto max-h-96 top-2 md:top-10 m-auto bg-ab-tertiary bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600 p-50'>
          <div
            className='absolute right-2 top-2 cursor-pointer'
            onClick={() => {
              setOpenModal(false);
            }}
          >
            X
          </div>

          <h2 className='font-bold text-center'>
            {clickedStatus === 'pending'
              ? 'Are you sure?'
              : clickedStatus === 'accepted'
              ? 'Are you sure, you want to accept?'
              : 'Are you sure, this is not needed to be evaluated?'}
          </h2>

          <hr />

          <div className='flex justify-end items-center mt-4'>
            <button
              className='bg-red-c3 p-1 px-2 rounded-md text-white'
              onClick={() => {
                tableProps.statusChangeFn(
                  params.data.submissionId,
                  clickedStatus,
                  []
                );
                setOpenModal(false);
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default StatusDropdown;
